import { render } from "./i-close.vue?vue&type=template&id=c8d07e64"
import script from "./i-close.vue?vue&type=script&lang=js"
export * from "./i-close.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__